import {
  CommonModule,
  LocationStrategy,
  PathLocationStrategy,
  registerLocaleData,
} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { NgModule } from '@angular/core';
/** Modules */
// bootstrap modules
// app modules & core modules
import { environment } from '@wz-environments';
import { ClientDetailsService } from '@wz-services';
import { TunnelSanteCoreModule } from 'libs/modules/tunnelsante/tunnelsante-core.module';
import { CookieModule, CookieService } from 'ngx-cookie';
import { AppTunnelComponent } from './app-tunnel.component';
import { ToastService } from './components/toaster/toast.service';
import { TunnelAuthorizationGuard } from './guards/tunnel-authorization.guard';
import { BrokerAppDataService } from './services/tunnel-app-data.service';
import { AfiAuthenticationService } from './services/tunnel-authentication.service';
import { TunnelNavigationService } from './services/tunnel-navigation.service';
registerLocaleData(localeFr);

const services = [
  TunnelNavigationService,
  AfiAuthenticationService,
  ClientDetailsService,
  ToastService,
];
const guards = [TunnelAuthorizationGuard];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CookieModule.withOptions({
      path: '/', // default path
      sameSite: 'lax', // recommended default
      secure: environment.name == 'production',
    }),
    CookieModule.forRoot(),
    TunnelSanteCoreModule,
  ],
  exports: [TunnelSanteCoreModule],
  providers: [
    CookieService,
    {
      provide: 'COOKIE_OPTIONS',
      useValue: {
        path: '/',
        sameSite: 'lax',
        secure: environment.name == 'production',
      },
    },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
    ...services,
    ...guards,
    BrokerAppDataService,
  ],
  bootstrap: [AppTunnelComponent],
})
export class AppTunnelModule {}
